export default "__VITE_ASSET__7eUUutqy__"